import { memberRoles } from "~/lib/iam/roles";
import { Role } from "~/lib/iam/roles";
import { roleExceptionReviewer } from "~/lib/iam/roles/ExceptionReviewer";
import { roleExceptionsRequester } from "~/lib/iam/roles/ExceptionsRequester";
import { roleIntegrationsManager } from "~/lib/iam/roles/IntegrationsManager";
import { rolePolicyEditor } from "~/lib/iam/roles/PolicyEditor";
import { rolePolicyManager } from "~/lib/iam/roles/PolicyManager";
import { roleQueryPackEditor } from "~/lib/iam/roles/QueryPackEditor";
import { roleQueryPackManager } from "~/lib/iam/roles/QueryPackManager";
import { roleSlaManager } from "~/lib/iam/roles/SlaManager";
import { roleTicketCreator } from "~/lib/iam/roles/TicketCreator";
import { roleTicketManager } from "~/lib/iam/roles/TicketManager";

type RoleOption = {
  label: string;
  value: string;
};

// Helper to convert auto-generated roles to the { label, value } format
const toRoleOption = (role: Role): RoleOption => ({
  label: role.title.replace("Space ", ""),
  value: role.mrn,
});
export const BASE_MEMBERS_ROLES: RoleOption[] = memberRoles.map(toRoleOption);

// Detailed permission roles available for member assignment
const detailedPermissionRoles = [
  roleExceptionReviewer,
  roleExceptionsRequester,
  roleIntegrationsManager,
  rolePolicyEditor,
  rolePolicyManager,
  roleQueryPackEditor,
  roleQueryPackManager,
  roleSlaManager,
  roleTicketCreator,
  roleTicketManager,
] as const;

export const PERMISSIONS: RoleOption[] =
  detailedPermissionRoles.map(toRoleOption);

export enum MemberRoleGroupLabel {
  Base = "Base Roles",
  Detailed = "Detailed Permissions",
}

export const GROUPED_MEMBERS_ROLES = [
  {
    groupLabel: MemberRoleGroupLabel.Base,
    options: BASE_MEMBERS_ROLES,
  },
  {
    groupLabel: MemberRoleGroupLabel.Detailed,
    options: PERMISSIONS,
  },
];
